const defaultIndustrySettings = {
  cpdPoints: 25,
  cpdDay: 30,
  cpdMonth: 6
}

export default defaultIndustrySettings;



// WEBPACK FOOTER //
// ./src/constants/industry-settings.js